import { forwardRef, type InputHTMLAttributes } from 'react';

type InputVariant = 'default' | 'filled' | 'subtle';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  variant?: InputVariant;
  inputSize?: 'sm' | 'lg';
}

const variantStyles: Record<InputVariant, string> = {
  default: [
    'bg-white text-gray-800 border-gray-300 placeholder:text-gray-400',
    'focus:ring-pink-500 focus:border-pink-400',
    'dark:bg-gray-800 dark:text-gray-100 dark:border-gray-600 dark:placeholder:text-gray-500',
  ].join(' '),
  filled: [
    'bg-pink-50 text-gray-800 border-pink-200 placeholder:text-gray-500',
    'focus:ring-pink-500 focus:border-pink-400',
    'dark:bg-pink-950 dark:text-gray-100 dark:border-pink-800 dark:placeholder:text-gray-400',
  ].join(' '),
  subtle: [
    'bg-gray-50 text-gray-700 border-gray-200 placeholder:text-gray-400',
    'focus:ring-pink-300 focus:border-pink-300',
    'dark:bg-gray-800 dark:text-gray-200 dark:border-gray-600 dark:placeholder:text-gray-500',
  ].join(' '),
};

const sizeStyles = {
  sm: 'px-3 py-2 text-sm',
  lg: 'px-4 py-3 text-base',
};

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ variant = 'default', inputSize = 'sm', className = '', ...props }, ref) => (
    <input
      ref={ref}
      className={`border rounded-lg focus:outline-none focus:ring-2 ${sizeStyles[inputSize]} ${variantStyles[variant]} ${className}`}
      {...props}
    />
  ),
);

Input.displayName = 'Input';
export default Input;
